module.exports = __webpack_public_path__ + "img/antes_despues_24.5678e7ab.png";